export interface QuotationCardProps {
  title: string
  description: any
}

export const useQuotationCard = (props: QuotationCardProps) => {
  return {
    ...props,
  }
}
